<ng-container class="card" data-at-remote-inspection-card>
  <app-panel data-at-active-error [expanded]="true" [expandable]="true">
    <app-panel-header>
      <div class="card-owner-header flex flex-row gap-[8px] justify-between items-stretch">
        <span>
          {{
            '+INSTALLATIONS.INSTALLATION.MENU_BAR.DIAGNOSIS.PERMANENT_INSPECTION.TITLE' | translate
          }}
        </span>
        <ng-container *ngIf="isMaintainerWithFreeOrBasicOrPlusPackage">
          <div class="installation-package">
            <span
              [matTooltip]="'+REMOTE_SERVICE.BASIC_PACKAGE_TOOLTIP' | translate"
              matTooltipPosition="above"
            >
              {{ '+BOOKING.PLAN.BASIC_PACKAGE' | translate }}
            </span>
          </div>
        </ng-container>
      </div>
    </app-panel-header>
    <app-panel-content class="panel-content">
      <ng-container
        *ngIf="
          (remoteServiceStore.remoteServiceDiagnosisLoadingStatus$ | async) ===
            RemoteServiceDiagnosisLoadingStatus.DataLoading;
          else loaded
        "
      >
        <vi-loader
          body
          [isLoading]="true"
          message="{{ '+REMOTE_SERVICE.LOADING_DATA' | translate }}"
        ></vi-loader>
      </ng-container>

      <ng-template #loaded>
        <ng-container
          *ngIf="
            deviceStore.isLegacyDeviceWithoutBoilerSerial$ | async;
            else isNotLegacyOrHasBoilerSerialDevice
          "
        >
          <div class="status-entry no-data">
            <span class="no-data">
              {{ '+REMOTE_SERVICE.LEGACY_DEVICE_MISSING_SERIAL' | translate }}
            </span>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #isNotLegacyOrHasBoilerSerialDevice>
        <div *ngIf="!(isPermanentInspectionEntriesVisible$ | async); else dataAvailable">
          <ng-container
            *ngIf="
              isMaintainerWithFreeOrBasicOrPlusPackage && (isE3HeatpumpDevice$ | async);
              else isNotMaintainerWithFreeOrBasicOrPlusPackageNoData
            "
          >
            <div class="status-entry no-data">
              <span class="no-data">
                {{
                  diagnosisCalculationDataStatus ===
                    RemoteServiceDiagnosisLoadingStatus.DiagnosisCalculationsNotReadyYet &&
                  !(installationDetailsStore.getGatewayStatus(gatewaySerial) | async).offline
                    ? ('+REMOTE_SERVICE.NO_ENOUGH_DATA_BASIC_AND_E3_HEATPUMP' | translate)
                    : ('+REMOTE_SERVICE.NO_DATA_AVAILABLE' | translate)
                }}
              </span>
            </div>
          </ng-container>

          <ng-template #isNotMaintainerWithFreeOrBasicOrPlusPackageNoData>
            <div class="status-entry no-data">
              <span class="no-data">
                {{
                  diagnosisCalculationDataStatus ===
                    RemoteServiceDiagnosisLoadingStatus.DiagnosisCalculationsNotReadyYet &&
                  !(installationDetailsStore.getGatewayStatus(gatewaySerial) | async).offline
                    ? ('+REMOTE_SERVICE.NO_ENOUGH_DATA' | translate)
                    : ('+REMOTE_SERVICE.NO_DATA_AVAILABLE' | translate)
                }}
              </span>
            </div>
          </ng-template>
        </div>
      </ng-template>

      <ng-template #dataAvailable>
        <div class="card-content">
          <ng-container *ngIf="anomaliesList.length > 0; else noAnomalies">
            <ng-container *ngFor="let anomaly of anomaliesList; let i = index">
              <div
                class="status-entry"
                [ngClass]="remoteServiceService.getDiagnosisStatusClass(anomaly)"
                *ngIf="canDisplayDiagnosisEntry(i)"
              >
                <div class="status-details">
                  <div class="status-header flex flex-wrap">
                    <span class="status-title mb-1 block">
                      {{ getRemoteServicePrefix(anomaly.diagnosis_group) | translate }}
                    </span>
                    <div class="flex flex-row ml-3 gap-1">
                      <app-pill [type]="remoteServiceService.getDiagnosisStatusPillType(anomaly)">
                        {{ remoteServiceService.getDescriptionKeyByRiskValue(anomaly) | translate }}
                      </app-pill>

                      <app-pill
                        *ngIf="anomaly.diagnosis_id_display"
                        [type]="remoteServiceService.getDiagnosisStatusPillType(anomaly)"
                      >
                        {{ anomaly.diagnosis_id_display }}
                      </app-pill>
                      <app-pill *ngFor="let tag of anomaly.tags" [attr.data-at-anomaly-tag]="tag">
                        {{
                          customTranslationsService.REMOTE_SERVICE_DIAGNOSIS_TAGS[tag] | translate
                        }}
                      </app-pill>
                    </div>
                  </div>
                  <span class="status-description">
                    • {{ getRemoteServicePrefix(anomaly.diagnosis_text) | translate }}
                  </span>
                  <span
                    class="status-anomaly"
                    [matTooltip]="'+REMOTE_SERVICE_SIDENAV_BUTTON_DISABLED_DIAGNOSTICS' | translate"
                    matTooltipPosition="above"
                    [matTooltipDisabled]="!(uiService.isDiagnosticOverlayOpen$ | async)"
                  >
                    <button
                      class="status-anomaly__btn"
                      gtm="onOpen"
                      gtmAction="Open detailed diagnosis"
                      gtmCategory="RemoteInspection"
                      appSmallButton
                      color="secondary"
                      (click)="navigateToSelectedAnomaly(anomaly)"
                      mat-stroked-button
                      [disabled]="uiService.isDiagnosticOverlayOpen$ | async"
                    >
                      {{ '+REMOTE_SERVICE.SHOW_ANOMALY_BTN' | translate }}
                    </button></span
                  >
                </div>
              </div>
            </ng-container>
            <div class="button-wraper">
              <div class="show-more-btn-wrapper" *ngIf="isMoreButtonVisible()">
                <ng-container
                  *ngIf="canDisplayAllEntries; then showLessButton; else showMoreButton"
                ></ng-container>
              </div>

              <ng-template #showMoreButton>
                <button
                  mat-stroked-button
                  class="small-btn"
                  gtm="onToggle"
                  gtmAction="Expand Remote Inspection Sidenav"
                  gtmCategory="RemoteInspection"
                  (click)="showMore()"
                >
                  <span>{{ 'GENERAL.BUTTON.SHOW_MORE' | translate }}</span>
                  <mat-icon>expand_more</mat-icon>
                </button>
              </ng-template>

              <ng-template #showLessButton>
                <button
                  mat-stroked-button
                  class="small-btn"
                  color="accent"
                  gtm="onToggle"
                  gtmAction="Collapse Remote Inspection Sidenav"
                  gtmCategory="RemoteInspection"
                  (click)="showLess()"
                >
                  {{ 'GENERAL.BUTTON.SHOW_LESS' | translate }}
                  <mat-icon class="inverted-icon">expand_more</mat-icon>
                </button>
              </ng-template>
            </div>
          </ng-container>

          <ng-template #noAnomalies>
            <ng-container
              *ngIf="
                isMaintainerWithFreeOrBasicOrPlusPackage && (isE3HeatpumpDevice$ | async);
                else notMaintainerWithFreeOrBasicOrPlusPackageAndE3Heatpump
              "
            >
              <span
                class="no-anomalies-text"
                (click)="navigateToAnomalies()"
                gtm="onSelect"
                gtmAction="Navigate to anomalies"
                gtmCategory="RemoteInspection"
                [innerHTML]="
                  diagnosisCalculationDataStatus ===
                    RemoteServiceDiagnosisLoadingStatus.DiagnosisCalculationsNotReadyYet ||
                  anomaliesWithMaintainerFreeOrBasicOrPlusPackage.length > 0
                    ? ('+REMOTE_SERVICE.PERMANENT_INSPECTION.ACTIVE' | translate | viTrustHtml)
                    : ('+REMOTE_SERVICE.NO_ENOUGH_DATA_BASIC_AND_E3_HEATPUMP'
                      | translate
                      | viTrustHtml)
                "
              >
                <mat-icon>check_circle_outline</mat-icon></span
              >
            </ng-container>
            <ng-template #notMaintainerWithFreeOrBasicOrPlusPackageAndE3Heatpump>
              <span
                class="no-anomalies-text"
                (click)="navigateToAnomalies()"
                gtm="onSelect"
                gtmAction="Navigate to anomalies"
                gtmCategory="RemoteInspection"
                [innerHTML]="
                  diagnosisCalculationDataStatus ===
                  RemoteServiceDiagnosisLoadingStatus.DiagnosisCalculationsNotReadyYet
                    ? ('+REMOTE_SERVICE.NO_ENOUGH_DATA' | translate | viTrustHtml)
                    : ('+REMOTE_SERVICE.NO_ANOMALIES_DETECTED_DESCRIPTION_SIDENAV'
                      | translate
                      | viTrustHtml)
                "
              >
                <mat-icon>check_circle_outline</mat-icon></span
              >
            </ng-template>
          </ng-template>
        </div>
      </ng-template>
    </app-panel-content>
  </app-panel>
</ng-container>
